<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-form :inline="true" :model="filters" ref="filters">
        <el-form-item>
          <el-input v-model.trim="filters.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="initT">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="buttonsAccess.indexOf('添加用户') > -1" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="users" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="userName" label="用户名称">
      </el-table-column>
      <el-table-column prop="nickName" label="用户昵称">
      </el-table-column>
      <el-table-column prop="sysRbacRoleNew.roleName" label="属于角色">
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status === 1 ? 'success' : 'danger'"
            close-transition>{{formatterStatus(scope.row.status)}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" width="170" label="更新时间">
      </el-table-column>
      <el-table-column label="操作" width="170" fixed="right" v-if="buttonsAccess.indexOf('操作-修改') > -1 || buttonsAccess.indexOf('操作-修改状态') > -1">
        <template slot-scope="scope">
          <el-button size="small" v-if="buttonsAccess.indexOf('操作-修改') > -1" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="small" type="danger" v-if="buttonsAccess.indexOf('操作-修改状态') > -1" @click="handleEditStatus(scope.$index, scope.row)">更改状态</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :total="total"
                     :page-size="pageSize" :current-page="pageNum" style="float:right;">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" :rules="addFormRules" ref="addForm" label-width="100px">
        <el-form-item label="用户名" prop="username" required>
          <el-input v-model="addForm.username" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="nickname">
          <el-input v-model="addForm.nickname" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input v-model="addForm.pass" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="vpass" required>
          <el-input v-model="addForm.vpass" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="授权角色" prop="role">
          <el-select v-model="addForm.role" filterable placeholder="请选择">
            <el-option
              v-for="item in roleOptions"
              :label="item.roleName"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click="addSubmit('addForm')" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">
        <el-form-item label="用户名" prop="username" required>
          <el-input v-model="editForm.username" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="nickname">
          <el-input v-model="editForm.nickname" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input v-model="editForm.pass" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="vpass" required>
          <el-input v-model="editForm.vpass" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="授权角色" prop="role">
          <el-select v-model.number="editForm.role" filterable placeholder="请选择">
            <el-option
              v-for="item in roleOptions"
              :label="item.roleName"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click="editSubmit('editForm')" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
  import md5 from 'crypto-js/md5'
  import {getUserList,getRoleList,saveUserRole,updateUserRole,validationUsername} from '../../api/api';

  export default {
    data() {
      var validatePass2E = (rule, value, callback) => {
        if (value !== this.editForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.addForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validationUsername1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入用户名'));
        }  else {
          let para = {
            username: value
          };
          validationUsername(para).then((res) => {
            if(res.data.status == 200){
              callback();
            }else{
              callback(new Error('用户名重复!'));
            }
          });
        }
      };
      var validationUsername1E = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入用户名'));
        }  else if(value==this.editForm.username){
          callback();
        }else{
          let para = {
            username: value
          };
          validationUsername(para).then((res) => {
            if(res.data.status == 200){
              callback();
            }else{
              callback(new Error('用户名重复!'));
            }
          });
        }
      };
      return {
        //按钮权限
        buttonsAccess:this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[this.$route.meta.id]?this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[this.$route.meta.id].buttons:[],
        //列表
        filters: {
          username: ''
        },
        users: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
        listLoading: false,
        //新增界面
        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          username: [
            {validator: validationUsername1, trigger: 'blur'},
            { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' }
          ],
          nickname: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          pass: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' }
          ],
          vpass: [
            {validator: validatePass2,trigger: 'blur'}
          ],
          role: [
            {required: true, type:'number', message: '请选择授予角色', trigger: 'change'}
          ]
        },
        addForm: {
          username: '',
          nickname: '',
          pass: '',
          vpass: '',
          role: ''
        },
        roleOptions: [],
        //编辑界面
        editFormVisible: false,//编辑界面是否显示
        editLoading: false,
        editFormRules: {
          username: [
            {validator: validationUsername1E, trigger: 'blur'},
            { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' }
          ],
          nickname: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          pass: [
            { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' }
          ],
          vpass: [
            {validator: validatePass2E,trigger: 'blur'}
          ],
          role: [
            {required: true, type:'number', message: '请选择授予角色', trigger: 'change'}
          ]
        },
        editForm: {
          id: 0,
          username: '',
          ousername: '',
          nickname: '',
          pass: '',
          vpass: '',
          role: ''
        }
      }
    },
    methods: {
      initT() {
        let para = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          username: this.filters.username.toString().trim()
        };
        this.listLoading = true;
        getUserList(para).then((res) => {
          this.total = res.data.data.total;
          this.users = res.data.data.list;
          this.listLoading = false;
        });
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.initT();
      },
      formatterStatus(val) {
        return val === 1 ? '正常' : '已删除';
      },
      //显示新增界面
      handleAdd: function () {
        this.addFormVisible = true;
        if(this.$refs['addForm']){
          this.resetForm('addForm')
        }
        getRoleList().then((res) => {
          this.roleOptions=res.data.data.list
        });
      },
      //新增
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              let formData = new FormData();
              formData.append('userName', this.addForm.username);
              formData.append('nickName', this.addForm.nickname);
              formData.append('passWord', md5(this.addForm.vpass));
              formData.append('sysRbacRoleNew.id', this.addForm.role);
              saveUserRole(formData).then((res) => {
                this.addLoading = false;
                if (res.data.status == 200) {
                  this.$notify({
                    title: '成功',
                    message: '提交成功',
                    type: 'success'
                  });
                  this.addFormVisible = false;
                  this.$refs['addForm'].resetFields();
                  this.initT();
                } else {
                  this.$notify({
                    title: '失败',
                    message: res.data.msg,
                    type: 'error'
                  });
                }
              });
            });
          }
        });
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        if (row.id == 1) {
          this.$notify({
            title: '警告',
            message: '管理员不可更改！',
            type: 'warning'
          });
        } else {
          this.editFormVisible = true;
//        this.editForm = Object.assign({}, row);
          getRoleList().then((res) => {
            this.roleOptions = res.data.data.list
          });
          this.editForm = {
            id: row.id,
            username: row.userName,
            ousername: row.userName,
            nickname: row.nickName,
            pass: '',
            vpass: '',
            role: Number(row.sysRbacRoleNew.id)
          }
        }
      },
      //编辑
      editSubmit: function () {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              let formData = new FormData();
              formData.append('id', this.editForm.id);
              formData.append('userName', this.editForm.username);
              formData.append('nickName', this.editForm.nickname);
              if(this.editForm.vpass){
                formData.append('passWord', md5(this.editForm.vpass));
              }
              formData.append('sysRbacRoleNew.id', this.editForm.role);
              updateUserRole(formData).then((res) => {
                this.editLoading = false;
                if (res.data.status == 200) {
                  this.$notify({
                    title: '成功',
                    message: '提交成功',
                    type: 'success'
                  });
                  this.editFormVisible = false;
                  this.$refs['editForm'].resetFields();
                  this.initT();
                } else {
                  this.$notify({
                    title: '失败',
                    message: res.data.msg,
                    type: 'error'
                  });
                }
              });
            });
          }
        });
      },
      handleEditStatus: function (index, row) {
        if (row.id == 1) {
          this.$notify({
            title: '警告',
            message: '管理员不可更改！',
            type: 'warning'
          });
        } else {
          let formData = new FormData();
          formData.append('id', row.id);
          if(row.status === 1){
            formData.append('status', 0);
          }else{
            formData.append('status', 1);
          }
          updateUserRole(formData).then((res) => {
            if (res.data.status == 200) {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success'
              });
              this.initT();
            } else {
              this.$notify({
                title: '失败',
                message: res.data.msg,
                type: 'error'
              });
            }
          });
        }
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
    mounted() {
      this.initT();
    }
  }

</script>

<style scoped>

</style>
